// eslint-disable-next-line import/prefer-default-export
export const CURRENCIES: string[] = ['CZK', 'EUR', 'HUF', 'PLN'];
